import React from "react";
import styled from "styled-components";

interface Props {
  name: string;
  options: Array<{
    label: string;
    value: string;
    className?: string;
    acceptBgColor?: string;
    acceptColor?: string;
  }>;
  onChange: (value: string) => void;
  selected: string;
  style: React.CSSProperties;
}

const SolidRadio = ({
  name,
  options,
  selected,
  onChange,
  ...restProps
}: Props) => {
  return (
    <>
      {options.map((iData) => (
        <LabelStyled
          $isActive={selected === iData.value}
          className={`radio-label-wrapper ${iData?.className || ""}`}
          $acceptColor={iData?.acceptColor}
          $acceptBgColor={iData?.acceptBgColor}
        >
          <RadioInputStyled
            type="radio"
            name={name}
            value={iData?.value}
            onClick={() => onChange(iData.value)}
            {...restProps}
          />
          {iData?.label}
          <div className="radio-label">{iData?.label}</div>
        </LabelStyled>
      ))}
    </>
  );
};

export default SolidRadio;

const RadioInputStyled = styled.input`
  opacity: 0;
  height: 0;
  width: 0;
`;

const LabelStyled = styled.label<{
  $isActive: boolean;
  $acceptColor?: string;
  $acceptBgColor?: string;
}>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  position: relative;
  height: 36px;
  width: fit-content;
  & .radio-label {
    cursor: pointer;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    padding: 6px 3px;
    border-radius: 6px;
    text-align: center;
    border: 1px solid #dbdbdb;
    background: ${({ theme, $isActive, $acceptBgColor }) =>
      $isActive
        ? $acceptBgColor || theme?.colors?.primary
        : theme?.colors?.background};
    color: ${({ theme, $isActive, $acceptColor }) =>
      $isActive
        ? $acceptColor || theme?.colors?.light.ivory
        : theme?.colors?.dark.black};
  }
`;
